import { React, useState, useEffect } from "react";
import ReactMarkDown from 'react-markdown';
import {LoadingOutlined} from '@ant-design/icons';
import {Flex} from 'antd';

const MdText = (props) => {
    const [text, setText] = useState(false);
    useEffect(() => {
        setText(false);
        const fetchText = async () => {
            await fetch(props.url)
                .then(response => response.text())
                .then(text => setText(text));
        }
        fetchText();
    }, [props.url]);
    if(text) {
        return (<ReactMarkDown>
            {text}
        </ReactMarkDown>);
    } else {
        return (<Flex align="center" justify="center" style={{width: "100%", height:"100%"}}>
            <LoadingOutlined/>
        </Flex>);
    }
}
export default MdText;